<template>
  <b-container fluid>
    <h3 class="mt-3 mb-3">Password Update</h3>

    <b-form-group
      id="grp_txt_username"
      label="Username:"
      label-for="txt_username"
      label-size="sm"
    >
      <b-form-input
        id="txt_username"
        disabled
        type="text"
        required
        placeholder
        v-model="$store.state.user_obj.name"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      id="grp_txt_password"
      label="Current Password:"
      label-for="txt_password"
      label-size="sm"
    >
      <b-form-input
        id="txt_password"
        type="password"
        required
        placeholder
        v-model="current_password"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      id="grp_txt_password"
      label="New Password:"
      label-for="txt_password"
      label-size="sm"
    >
      <b-form-input
        id="txt_password"
        type="password"
        required
        placeholder
        v-model="new_password"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      id="grp_txt_password"
      label="Confirm New Password:"
      label-for="txt_password"
      label-size="sm"
    >
      <b-form-input
        id="txt_password"
        type="password"
        required
        placeholder
        v-model="confirm_new_password"
      ></b-form-input>
    </b-form-group>

    <b-button class="float-right" type="submit" variant="info" @click="doChangePassword()"
      >Submit</b-button
    >
  </b-container>
</template>

<script>
import TextCollapse from "@/components/TextCollapse.vue";

const fields = [
  {
    key: "id",
    label: "ID",
  },
  {
    key: "account_type",
    label: "Account Type",
  },
  {
    key: "username",
    label: "Username",
  },
  {
    key: "name",
    label: "Name",
  },
  {
    key: "phone",
    label: "Phone",
  },
  {
    key: "action",
    label: "Action",
  },
];

const account_type_options = [
  {
    value: null,
    text: "All Accounts",
  },
  {
    value: "admin",
    text: "Admin",
  },
  {
    value: "cs",
    text: "CS",
  },
  {
    value: "driver",
    text: "Driver",
  },
];

export default {
  name: "Users",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    TextCollapse,
  },
  data() {
    return {
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      search_criteria: {
        keyword: "",
        account_type: null,
      },
      showDismissibleAlert: false,
      account_type_options: account_type_options,
      updating_item: false,
      change_password: "",
      username: "",
      current_password: "",
      new_password: "",
      confirm_new_password: "",
    };
  },
  async created() {
    // await this.getUsers();
  },
  mounted() {
    // this.loader = this.$loading.show({
    //   isFullPage: true,
    //   canCancel: false
    // });
  },
  methods: {
    async getUsers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "user_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
        },
      });
      this.items = response.data.users;
      this.total_rows = parseInt(response.data.total_rows);

      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getUsers();
    },

    checkAllRows() {
      console.log("checkAllRows");
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getUsers();
    },

    showModal_delete_confirm(item) {
      this.$refs.modal_delete_confirm.item = item;
      this.$refs.modal_delete_confirm.show();
    },

    hideModal_delete_confirm() {
      this.$refs.modal_delete_confirm.hide();
    },

    showModal_change_password(item) {
      this.updating_item = item;
      this.change_password = "";
      this.$refs.modal_change_password.show();
    },

    hideModal_change_password() {
      this.$refs.modal_change_password.hide();
    },

    async doChangePassword() {
      // checking
      if(this.current_password == '' || this.current_password.length < 8){
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Please enter a valid current password",
        });
        return;
      }

      if(this.new_password == '' || this.new_password.length < 8){
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Please enter a valid new password",
        });
        return;
      }

      if(this.confirm_new_password == '' || this.confirm_new_password.length < 8){
        this.$eventHub.$emit("show_modal_message", {
          message_content: "New Password not match",
        });
        return;
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "user_change_password.php",
        data: {
          user_id: this.$store.state.user_obj.user_id,
          username: this.$store.state.user_obj.username,
          new_password: this.new_password,
          current_password: this.current_password,
          first_time_login: 1,
        },
      });

      if (response.data.status == "success") {

        localStorage.setItem(
        "user_obj",
        JSON.stringify({
          user_id: this.$store.state.user_obj.user_id,
          user_name: this.$store.state.user_obj.username,
          account_type: this.$store.state.user_obj.account_type,
          name: this.$store.state.user_obj.name,
          permissions: this.$store.state.user_obj.permissions,
          sys_permissions: this.$store.state.user_obj.sys_permissions,
          client_id: this.$store.state.user_obj.client_id,
          first_time_login: 0
        })
      );

      this.$store.state.user_obj = {
        user_id: this.$store.state.user_obj.user_id,
          user_name: this.$store.state.user_obj.username,
          account_type: this.$store.state.user_obj.account_type,
          name: this.$store.state.user_obj.name,
          permissions: this.$store.state.user_obj.permissions,
          sys_permissions: this.$store.state.user_obj.sys_permissions,
          client_id: this.$store.state.user_obj.client_id,
          first_time_login: 0
      };

        this.$router.replace("/");
      } else {
        // prompt error
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.errorMsg,
        });
      }
    },

    async confirmDelete() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "driver_delete.php",
        data: {
          driver_id: this.$refs.modal_delete_confirm.item.id,
        },
      });

      if (response.data.status == "success") {
        this.getUsers();
      } else {
      }

      this.$refs.modal_delete_confirm.hide();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/AccountPasswordChange.vue